"use strict"

import {observable, action} from "mobx"
import moment from "moment"
import api from "../actions/api"
import VaccinationStore from "./VaccinationListStore"
import {exportToExcel, getUserCompanyInfo} from "../../../global/helpers/actions"
import settings from "../../../global/config/settings"

class ExportVaccListToXlsDialogStore {
	@observable isOpen = false

	@action open() {
		this.isOpen = true
	}

	@action close() {
		this.isOpen = false
	}

	@action ExportToXls(form) {
		let filters = []

		filters.push({
			associated_column: "company_id",
			values: [
				{
					id_value: getUserCompanyInfo()._id
				}
			]
		})

		if (isNotEmpty(form.values().exportType)) {
			filters.push({
				associated_column: "exportType",
				values: [
					{
						id_value: form.values().exportType
					}
				]
			})
		}

		if (isNotEmpty(VaccinationStore.vaccFormRef.$("org_unit").value)) {
			filters.push({
				associated_column: "provider_id",
				values: [{id_value: VaccinationStore.vaccFormRef.$("org_unit").value}]
			})
		}

		if (isNotEmpty(VaccinationStore.vaccFormRef.$("vacc_code").value)) {
			filters.push({
				associated_column: "vaccine_code_ext",
				values: [{id_value: VaccinationStore.vaccFormRef.$("vacc_code").value}]
			})
		}

		if (isNotEmpty(VaccinationStore.vaccFormRef.$("daysFromLastDose").value)) {
			filters.push({
				associated_column: "waiting_days",
				values: [{id_value: VaccinationStore.vaccFormRef.$("daysFromLastDose").value}]
			})
		}

		let req = {
			filters: filters,
			uri: api.loadVaccinationReport().getPath()
		}

		if (isNotEmpty(VaccinationStore.vaccFormRef.$("date_from").value)) {
			req["time_from"] = moment(VaccinationStore.vaccFormRef.$("date_from").value).format(settings.DB_DATETIME_FORMAT)
		}

		if (isNotEmpty(VaccinationStore.vaccFormRef.$("date_to").value)) {
			req["time_to"] = moment(VaccinationStore.vaccFormRef.$("date_to").value).format(settings.DB_DATETIME_FORMAT)
		}

		if (isSafe(VaccinationStore.medicationReportListRef)) {
			req.orders = [
				{
					associated_column: "created_at",
					asc: false
				}
			]
		}

		if (form.values().exportType == "now") {
			if (isSafe(VaccinationStore.medicationReportListRef)) {
				req.row_count_show = VaccinationStore.medicationReportListRef.state.rowsPerPage
				req.row_offset =
					VaccinationStore.medicationReportListRef.state.page *
						VaccinationStore.medicationReportListRef.state.rowsPerPage +
					1
			} else {
				req.row_offset = 1
				req.row_count_show = 10
			}
		}

		exportToExcel(req, () => {
			this.close(), form.reset()
		})
	}
}

var singleton = new ExportVaccListToXlsDialogStore()
export default singleton
